import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { LanguageService } from 'src/app/services/language.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { WhatsNewService } from 'src/app/services/whats-new.service';
import { VERSION_INFO } from 'src/app/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  appVersion = VERSION_INFO.version;
  isLoading = false; // No need to load from API anymore
  currentLanguage: string;
  private _langChangeSub?: Subscription;
  availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'es', name: 'Español' },
    { code: 'it', name: 'Italiano' },
    { code: 'de', name: 'Deutsch' },
    { code: 'zh', name: '繁體中文' },
    { code: 'ar', name: 'العربية' }
  ];

  constructor(
    private translate: TranslateService,
    public _permissionsService: PermissionsService,
    public _authService: AuthService,
    private _languageService: LanguageService,
    private _whatsNewService: WhatsNewService
  ) {
    this.currentLanguage = this.translate.currentLang || 'en';
  }

  ngOnInit() {
    // Reflect the active language (set on load from the user's saved preference).
    this.currentLanguage = this.translate.currentLang || 'en';
    // Keep the dropdown in sync when the language is changed programmatically
    // (e.g. on login the app switches to the user's saved language). The footer
    // is not recreated across the login -> app transition, so without this the
    // <select> would keep showing the pre-login language.
    this._langChangeSub = this.translate.onLangChange.subscribe(event => {
      this.currentLanguage = event.lang;
    });
  }

  ngOnDestroy() {
    this._langChangeSub?.unsubscribe();
  }

  // Opens What's New in a dialog. Ctrl/Cmd/middle-click still opens the /whats-new page in a new tab.
  openWhatsNew(event: MouseEvent) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }
    event.preventDefault();
    this._whatsNewService.open();
  }

  onLanguageChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const language = target.value;
    this.currentLanguage = language;
    // Apply immediately and persist to the logged-in user's Drupal account.
    this._languageService.changeLanguage(language);
  }
}
